import i18n from '../i18n';

/**
 * Adds language parameter to API URL
 * @param {string} url - The API URL
 * @returns {string} - URL with language parameter
 */
export const addLangParam = (url) => {
  const lang = i18n.language || 'he'; // Default to Hebrew
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}lang=${lang}`;
};

/**
 * Fetch wrapper that automatically adds language parameter
 * @param {string} url - The API URL
 * @param {object} options - Fetch options
 * @returns {Promise} - Fetch promise
 */
export const fetchWithLang = (url, options = {}) => {
  const urlWithLang = addLangParam(url);
  return fetch(urlWithLang, options);
};

export default {
  addLangParam,
  fetchWithLang
};
